import {gql} from '@apollo/client'

export const CREATE_SIGNATURE_FORM = gql`
  mutation createSignatureForm(
    $name: String!
    $description: String!
    $formContent: String!
    $emailContent: String
    $smsContent: String
    $status: String!
  ) {
    signatureFormCreate(
      input: {
        name: $name
        description: $description
        formContent: $formContent
        emailContent: $emailContent
        smsContent: $smsContent
        status: $status
      }
    ) {
      success
      signatureForm {
        id
        name
        user {
          id
          email
        }
      }
      errors {
        field
        message
      }
    }
  }
`
export const UPDATE_SIGNATURE_FORM = gql`
  mutation updateSignatureForm($id: ID!, $input: SignatureFormInput!) {
    signatureFormUpdate(id: $id, input: $input) {
      success
      signatureForm {
        id
        name
        user {
          id
          email
        }
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_SIGNATURE_FORM_STATUS = gql`
  mutation updateSignatureFormStatus($id: ID!, $status: String!) {
    signatureFormUpdateStatus(id: $id, status: $status) {
      success
      signatureForm {
        id
        name
        status
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_SIGNATURE_FORM = gql`
  mutation deleteSignatureForm($id: ID!) {
    deleteSignatureForm(id: $id) {
      success
      errors {
        message
      }
    }
  }
`

export const CREATE_SIGNATURE_FORMS_ENTRY = gql`
  mutation CreateSignatureFormsEntry(
    $formId: String!
    $sourceType: String!
    $sourceId: String!
    $agentId: String!
    $sendSms: Boolean!
    $shouldSendEmail: Boolean!
    $getSigningLink: Boolean!
  ) {
    createSignatureFormsEntry(
      formId: $formId
      sourceType: $sourceType
      sourceId: $sourceId
      agentId: $agentId
      sendSms: $sendSms
      shouldSendEmail: $shouldSendEmail
      getSigningLink: $getSigningLink
    ) {
      ok
      entryId
      signingLink
      emailSent
      errorMessage
    }
  }
`

export const MARK_SIGNAFTURE_FORMS_AS_VIEWED = gql`
  mutation markSignatureFormAsViewed($token: String!) {
    markSignatureFormAsViewed(token: $token) {
      ok
      logs {
        id
        action
        contact
        user {
          id
          firstName
          lastName
          email
        }
        ipAddress
        region
        browser
        isMobile
        created
      }
    }
  }
`

export const RESEND_SIGNATURE_FORM_ENTRY = gql`
  mutation ResendSignatureFormEntry($entryId: ID!, $shouldSendEmail: Boolean!, $sendSms: Boolean!, $getSigningLink: Boolean!) {
    resendSignatureFormEntry(entryId: $entryId, shouldSendEmail: $shouldSendEmail, sendSms: $sendSms, getSigningLink: $getSigningLink) {
      ok
      emailSent
      signingUrl
      errorMessage
    }
  }
`

export const DELETE_SIGNATURE_FORM_ENTRY = gql`
  mutation DeleteSignatureFormEntry($entryId: ID!) {
    deleteSignatureFormEntry(entryId: $entryId) {
      ok
      errorMessage
    }
  }
`
